import store from '@/store';
import useUtils from '@/composables/useUtils';

const useTourUtils = () => {
  const { formatDecimalNumber } = useUtils();

  const getTourFees = (tour) => {
    const { pricePerEnvironmentTicket } =
      store.getters['setting/globalSettings'];

    const accountCommission = +tour.accountCommission;
    const juraAccCommission = pricePerEnvironmentTicket * tour.passengerNum;
    const taxiCommission = +tour.taxiTotalFee;
    const tourTotalFee = accountCommission + juraAccCommission + taxiCommission;

    return {
      accountCommission,
      juraAccCommission,
      taxiCommission,
      tourTotalFee,
    };
  };

  const storeTour = (tour) => {
    store.commit('tourMultiple/storeTour', {
      ...store.getters['tourMultiple/tour'],
      ...tour,
    });
  };

  const updateTaxiRate = (taxiList, rate) =>
    taxiList.map((taxi) => {
      taxi.taxiRate = formatDecimalNumber(rate / taxiList.length);
      return taxi;
    });

  return {
    getTourFees,
    storeTour,
    updateTaxiRate,
  };
};

export default useTourUtils;
